export const TEN_BILLION = 10000000000;
